import { styled, SvgIcon } from '@/core/ui';
export const IconContainer = styled('div', { shouldForwardProp: (prop) => prop !== 'size' })(({ size }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: size == 'defaultSnackbarIconSize' ? '1.5rem' : '2rem',
    height: size == 'defaultSnackbarIconSize' ? '1.5rem' : '2rem',
}));
export const SvgIconSpined = styled(SvgIcon, { shouldForwardProp: (prop) => prop !== 'spin' })(({ spin }) => ({
    ...(spin && { animation: 'fa-spin 2s infinite linear' }),
}));
